export default "./../images/user-group-img.svg";